var map = {
	"./academy.svg": "d8dc",
	"./alibaba.svg": "5382",
	"./avatar.svg": "f2e9",
	"./aws.svg": "23f6",
	"./blog.svg": "9425",
	"./bootcamp.svg": "5ced",
	"./bulb.svg": "e9f9",
	"./cloud.svg": "2b35",
	"./customer.svg": "64ef",
	"./customer2.svg": "5cbc",
	"./globe.svg": "0de3",
	"./google.svg": "d950",
	"./jobseek.svg": "6d6c",
	"./microsoft.svg": "7b25",
	"./news.svg": "f212",
	"./partners.svg": "9c07",
	"./podcasts.svg": "bb2b",
	"./suitecase.svg": "524d",
	"./teamskill.svg": "8ead",
	"./upskilling.svg": "12ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";